import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import ProtectedRoute from "./ProtectedRoute";
import React from "react";

// Pages
const HomePage = lazy(() => import("../pages/home/page"));
const CategoriaPage = lazy(() => import("../pages/categoria/page"));
const ProveedorPage = lazy(() => import("../pages/proveedor/page"));
const ProductoPage = lazy(() => import("../pages/producto/page"));
const ProductoDetallePage = lazy(() => import("../pages/producto-detalle/page"));
const BuscarPage = lazy(() => import("../pages/buscar/page"));
const FavoritosPage = lazy(() => import("../pages/favoritos/page"));
const CarritoPage = lazy(() => import("../pages/carrito/page"));
const CheckoutPage = lazy(() => import("../pages/checkout/page"));
const CuentaPage = lazy(() => import("../pages/cuenta/page"));
const ContactoPage = lazy(() => import("../pages/contacto/page"));
const EnviosPage = lazy(() => import("../pages/envios/page"));
const DevolucionesPage = lazy(() => import("../pages/devoluciones/page"));
const TallasPage = lazy(() => import("../pages/tallas/page"));
const FAQPage = lazy(() => import("../pages/faq/page"));
const LibroReclamacionesPage = lazy(() => import("../pages/libro-reclamaciones/page"));
const PedidosPage = lazy(() => import("../pages/pedidos/page"));
const PacasPage = lazy(() => import("../pages/pacas/page"));
const LoginPage = lazy(() => import("../pages/login/page"));
const NotFoundPage = lazy(() => import("../pages/NotFound"));

const OfertasPage = lazy(() => import("../pages/ofertas/page"));
const SkinkersPage = lazy(() => import("../pages/skinkers/page"));
const EstacionesPage = lazy(() => import("../pages/estaciones/page"));
const FechasPage = lazy(() => import("../pages/fechas/page"));
const CheckoutpPage = lazy(() => import("../pages/checkoutp/page"));

// Helper
const protect = (page: React.ReactElement) => (
  <ProtectedRoute>{page}</ProtectedRoute>
);

const routes: RouteObject[] = [
  // 🔓 PÚBLICAS
  { path: "/login", element: <LoginPage /> },
  { path: "/pacas", element: <PacasPage /> },

  { path: "/", element: <HomePage /> },
  { path: "/ofertas", element: <OfertasPage /> },
  { path: "/estaciones", element: <EstacionesPage /> },
  { path: "/estaciones/:id_estacion", element: <EstacionesPage /> },
  { path: "/fechas", element: <FechasPage /> },
  { path: "/fechas/:id_fecha", element: <FechasPage /> },
  { path: "/skinkers", element: <SkinkersPage /> },

  { path: "/categoria/:id_categoria", element: <CategoriaPage /> },
  {
    path: "/categoria/:id_categoria/:id_subcategoria",
    element: <CategoriaPage />,
  },

  { path: "/proveedor", element: <ProveedorPage /> },
  { path: "/proveedor/:id", element: <ProveedorPage /> },
  { path: "/producto/:id", element: <ProductoPage /> },
  { path: "/producto-detalle/:id", element: <ProductoDetallePage /> },
  { path: "/buscar", element: <BuscarPage /> },

  { path: "/contacto", element: <ContactoPage /> },
  { path: "/envios", element: <EnviosPage /> },
  { path: "/devoluciones", element: <DevolucionesPage /> },
  { path: "/tallas", element: <TallasPage /> },
  { path: "/faq", element: <FAQPage /> },
  { path: "/libro-reclamaciones", element: <LibroReclamacionesPage /> },

  // 🔒 PROTEGIDAS
  { path: "/favoritos", element: protect(<FavoritosPage />) },
  { path: "/carrito", element: protect(<CarritoPage />) },
  { path: "/checkout", element: protect(<CheckoutPage />) },
  { path: "/checkoutp", element: protect(<CheckoutpPage />) },
  { path: "/cuenta", element: protect(<CuentaPage />) },
  { path: "/pedidos", element: protect(<PedidosPage />) },

  // ❌ 404
  { path: "*", element: <NotFoundPage /> },
];

export default routes;